export default __webpack_public_path__ + "static/media/t.9fb3c9fa.png";